import { FilterOption } from '../../../types/filters'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'name',
    label: 'Nombre',
    type: 'text'
  }
]
